// extracted by mini-css-extract-plugin
export default {"mask":"mask_mask__ceL16","slowFade":"mask_slowFade__lIx3E","maskImage":"mask_maskImage__Tv3Oz"};